import React, { useContext } from 'react';

import { SortEnum } from '../../../__generated__/globalTypes';

import { SortValues, Toolbar } from './Toolbar';
import { ProductListQueryContext } from './ProductListQueryProvider';

type Props = {
    breadcrumbLabel?: string;
};

export const ProductListToolbar: React.FC<Props> = ({ breadcrumbLabel }) => {
    const { pageInfo, setSortOrder, clearSort, loading, initialQueryVars } = useContext(ProductListQueryContext);

    const initial: SortValues | undefined = (() => {
        if (initialQueryVars.sortName === SortEnum.ASC) return SortValues.NameAsc;
        if (initialQueryVars.sortName === SortEnum.DESC) return SortValues.NameDesc;
        if (initialQueryVars.sortPrice === SortEnum.ASC) return SortValues.PriceAsc;
        if (initialQueryVars.sortPrice === SortEnum.DESC) return SortValues.PriceDesc;
        return SortValues.Relevance;
    })();

    return (
        <Toolbar
            pageInfo={pageInfo}
            setSortOrder={setSortOrder}
            loading={loading}
            clearSort={clearSort}
            initial={initial}
            breadcrumbLabel={breadcrumbLabel}
        />
    );
};
